import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import axios from "axios";

function ClientList({ onChangeList, onInitial, axValue, axLabel }) {
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const hasInitialized = useRef(false); // 🔒 this ensures initialization only once

  useEffect(() => {
    const fetchClientList = async () => {
      try {
        const response = await axios.get(
          "https://eps.elkomprintama.com/get/api/clients",
        );
        const clientData = response.data.result;

        const clientOptions = clientData.map((client) => ({
          value: client.cust_id,
          label: client.nme,
        }));

        setClients(clientOptions);

        if (!hasInitialized.current && clientOptions.length > 0) {
          const initialClient = {
            value: axValue || clientOptions[0].value,
            label: axLabel || clientOptions[0].label,
          };

          setSelectedClient(initialClient);
          if (onInitial && typeof onInitial === "function") {
            onInitial(initialClient.value);
          }

          hasInitialized.current = true; // ✅ prevent reinitialization
        }
      } catch (error) {
        console.error("Error fetching clients data:", error);
      }
    };

    fetchClientList();
  }, [axValue, axLabel, onInitial]);

  const handleClientChange = (selectedOption) => {
    setSelectedClient(selectedOption);
    onChangeList(selectedOption.value);
  };

  return (
    <>
      <label
        htmlFor="client_list"
        className="block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
      >
        Customer
      </label>
      <div className="control w-full">
        <Select
          options={clients}
          className="block w-full border border-green-400 text-gray-700  rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          id="client_list"
          name="client_list"
          onChange={handleClientChange}
          value={selectedClient}
          styles={{
            control: (provided, state) => ({
              ...provided,
              border: state.isFocused
                ? "2px solid #4CAF50"
                : "1px solid #ced4da",
              boxShadow: "none",
            }),
          }}
        />
      </div>
    </>
  );
}

export default ClientList;
